import { P2, H2 } from '@moneymade/moneymade-ui'
import PropTypes from 'prop-types'

import ImgLazy from 'components/ui/ImgLazy/ImgLazy'
import { getCdnImg } from 'utils/getters'
import styles from './QuoteBlock.module.scss'

const QuoteBlock = ({ webpart: { text, description, backgroundColor, textColor, image, quoteColor } }) => (
  <section className={styles.QuoteBlock} style={{ background: backgroundColor }}>
    <div className={`${styles.Block} ${styles.Left}`}>
      <div className={styles.LeftSide}>
        <i className={`${styles.QuoteImg} icon-quote`} style={{ color: quoteColor }} />
        <H2 type="heading" weight="normal" style={{ color: textColor }} className={styles.Title}>
          {text}
        </H2>

        <P2 weight="light" nestedStyles>
          <div
            style={{ color: textColor }}
            className={styles.Description}
            dangerouslySetInnerHTML={{ __html: description }}
          />
        </P2>
      </div>
    </div>

    <div className={styles.RightSide}>
      <div className={`${styles.ImgBlock} ${styles.Left}`}>
        <ImgLazy alt={text} src={getCdnImg(image, 500)} />
      </div>
    </div>
  </section>
)

QuoteBlock.propTypes = {
  webpart: PropTypes.shape({
    text: PropTypes.string,
    description: PropTypes.string,
    backgroundColor: PropTypes.string,
    textColor: PropTypes.string,
    image: PropTypes.string,
    quoteColor: PropTypes.string
  })
}

QuoteBlock.defaultProps = {
  webpart: {
    text: '',
    description: '',
    backgroundColor: '#000000',
    textColor: '#FFFFFF',
    image: '',
    quoteColor: '#00993F'
  }
}

export default QuoteBlock
